import { invariant } from "@rpldy/shared";
export var ERROR_MSG = "Uploady - valid UploadyContext not found. Make sure you render inside <Uploady>";
export default (function (context) {
  invariant(context && context.hasUploader(), ERROR_MSG);
  return context;
});